/** User-facing copy for premium report reader. Machine IDs stay in QA only. */

export const PHASE_LABEL_RU: Record<string, string> = {
  past: 'Прошло',
  current: 'Сейчас',
  upcoming: 'Впереди',
};

export const DATE_ROLE_LABEL_RU: Record<string, string> = {
  primary: 'ближайшая опорная дата',
  fixation: 'день, чтобы закрепить условия',
  alternative: 'запасное окно',
  supportive: 'дополнительная дата',
  start: 'Новое начало',
  partnership: 'Согласование',
  communication: 'Разговор',
  structure: 'Условия и закрепление',
  change: 'Новые варианты',
  care: 'Забота и ответственность',
  analysis: 'Разбор и ясность',
  money_result: 'Цена и переговоры',
  completion: 'Завершение',
};

const TAG_LABEL_RU: Record<string, string> = {
  care: 'забота',
  partnership: 'партнёрство',
  communication: 'разговор',
  money: 'деньги',
  career: 'работа',
  self: 'себе',
};

const MONTHS_RU_GENITIVE = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

export function localizeMachineLabel(value: string | undefined | null): string {
  if (!value) return '';
  return PHASE_LABEL_RU[value] || DATE_ROLE_LABEL_RU[value] || TAG_LABEL_RU[value] || value;
}

export function formatReportDateRu(iso: string | undefined | null): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso ?? ''));
  if (!match) return String(iso ?? '');
  return `${Number(match[3])} ${MONTHS_RU_GENITIVE[Number(match[2]) - 1]} ${match[1]}`;
}

function normalizeLabel(value: string): string {
  return value.toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
}

export function strongDateCaption(role: string | undefined | null, label: string | undefined | null): string {
  const roleRu = localizeMachineLabel(role);
  const labelText = String(label ?? '').trim();
  if (!roleRu) return labelText;
  if (!labelText) return roleRu;
  const roleNorm = normalizeLabel(roleRu);
  const labelNorm = normalizeLabel(labelText);
  if (labelNorm.includes(roleNorm) || roleNorm.includes(labelNorm)) return labelText;
  // label is the calendar date («18 сентября») → show theme only; date is already the heading.
  if (/\d{1,2}\s+(января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)/i.test(labelText)) {
    return roleRu;
  }
  return `${labelText} · ${roleRu}`;
}

export type ComposerMessageOrigin = 'typed' | 'suggested_question' | 'edited_suggestion' | 'user_confirmation';

export function resolveComposerOrigin(currentText: string, sourceSuggestion: string | null | undefined): ComposerMessageOrigin {
  const text = currentText.trim();
  const source = sourceSuggestion?.trim() ?? '';
  if (!source || !text) return 'typed';
  if (text === source) return 'suggested_question';
  return 'edited_suggestion';
}

export function splitNarrativeParagraphs(text: string | undefined | null): string[] {
  const raw = String(text ?? '').replace(/\r\n/g, '\n').trim();
  if (!raw) return [];
  const byBlank = raw.split(/\n{2,}/).map(part => part.replace(/\n/g, ' ').trim()).filter(Boolean);
  if (byBlank.length > 1) return byBlank;
  const lines = raw.split('\n').map(part => part.trim()).filter(Boolean);
  if (lines.length > 1 && lines.every(line => line.length >= 40)) return lines;
  return [raw.replace(/\n/g, ' ').trim()].filter(Boolean);
}
